import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'membership_mytrips_reactivation';
export const route = 'membership_mytrips_reactivation/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipmytripsreactivation" */
'../../components/MembershipMyTripsReactivation')));